(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var cartLinks = Array.from(document.querySelectorAll('[data-sunbum-cart-link]'));
    var cartCounts = Array.from(document.querySelectorAll('[data-sunbum-cart-count]'));
    if (!cartLinks.length || !cartCounts.length) return;

    function formatCount(count) {
      return count > 99 ? '99+' : String(Math.max(0, count));
    }

    function persistCount(count) {
      try {
        window.sessionStorage.setItem('cart-count', JSON.stringify({
          value: String(count),
          timestamp: Date.now()
        }));
      } catch (_error) {
        return;
      }
    }

    function renderCount(count, shouldPersist) {
      var normalizedCount = Number.isFinite(count) ? Math.max(0, count) : 0;
      var formattedCount = formatCount(normalizedCount);
      cartCounts.forEach(function (countNode) {
        countNode.textContent = formattedCount;
        countNode.setAttribute('data-cart-count', String(normalizedCount));
      });
      cartLinks.forEach(function (link) {
        link.setAttribute('aria-label', normalizedCount === 1 ? 'Cart, 1 item' : 'Cart, ' + normalizedCount + ' items');
      });
      if (shouldPersist !== false) {
        persistCount(normalizedCount);
      }
    }

    function syncFromStorage() {
      try {
        var storedValue = window.sessionStorage.getItem('cart-count');
        if (!storedValue) return false;
        var parsedValue = JSON.parse(storedValue);
        if (!parsedValue || typeof parsedValue.value === 'undefined') return false;
        if (typeof parsedValue.timestamp === 'number' && Date.now() - parsedValue.timestamp > 10000) return false;
        var count = parseInt(parsedValue.value, 10);
        if (!Number.isFinite(count)) return false;
        renderCount(count, false);
        return true;
      } catch (_error) {
        return false;
      }
    }

    function syncFromCart() {
      return fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (!cart || typeof cart.item_count !== 'number') return;
          renderCount(cart.item_count);
        })
        .catch(function () {
          return;
        });
    }

    function scheduleCartSync() {
      window.setTimeout(syncFromCart, 120);
      window.setTimeout(syncFromCart, 900);
    }

    function isCartMutationUrl(url) {
      return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
    }

    window.__sunbumHeaderCartSync = scheduleCartSync;

    if (!window.__sunbumCartFetchPatched && typeof window.fetch === 'function') {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function () {
        var input = arguments[0];
        var url = typeof input === 'string'
          ? input
          : input && typeof input.url === 'string'
            ? input.url
            : '';
        var responsePromise = originalFetch.apply(window, arguments);

        if (isCartMutationUrl(url)) {
          responsePromise
            .then(function (response) {
              if (!response || !response.ok || typeof window.__sunbumHeaderCartSync !== 'function') return;
              window.__sunbumHeaderCartSync();
            })
            .catch(function () {
              return;
            });
        }

        return responsePromise;
      };
      window.__sunbumCartFetchPatched = true;
    }

    if (!window.__sunbumCartSubmitPatched) {
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
        if (typeof window.__sunbumHeaderCartSync === 'function') {
          window.__sunbumHeaderCartSync();
        }
      }, true);
      window.__sunbumCartSubmitPatched = true;
    }

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        syncFromStorage();
        syncFromCart();
      }
    });

    syncFromStorage();
    syncFromCart();
  });
})();
